import React from "react";
import { Modal } from "react-bootstrap";

const DomainDetailModal = ({show,handleClose,domain}) => {

if(!domain) return null;

return(

<Modal show={show} onHide={handleClose} centered size="md">

<Modal.Header closeButton>

<Modal.Title>

Domain Detail

<span
style={{
marginLeft:"10px",
background:"#e6f7ec",
color:"#2ecc71",
padding:"4px 10px",
borderRadius:"5px",
fontSize:"12px"
}}
>

{domain.status}

</span>

</Modal.Title>

</Modal.Header>

<Modal.Body>

<div
style={{
background:"#f6f7fb",
padding:"15px",
borderRadius:"8px",
marginBottom:"15px"
}}
>

<div className="d-flex align-items-center">

<img
src={domain.logo}
style={{
width:"40px",
height:"40px",
borderRadius:"50%",
marginRight:"10px"
}}
/>

<strong>{domain.name}</strong>

</div>

</div>

<div className="row">

<div className="col-md-4 mb-3">
<span style={{fontSize:"12px"}}>Plan Name</span>
<h6>{domain.planName}</h6>
</div>

<div className="col-md-4 mb-3">
<span style={{fontSize:"12px"}}>Plan Type</span>
<h6>{domain.planType}</h6>
</div>

<div className="col-md-4 mb-3">
<span style={{fontSize:"12px"}}>Account URL</span>
<h6>{domain.url}</h6>
</div>

<div className="col-md-4 mb-3">
<span style={{fontSize:"12px"}}>Price</span>
<h6>{domain.price}</h6>
</div>

<div className="col-md-4 mb-3">
<span style={{fontSize:"12px"}}>Register Date</span>
<h6>{domain.created}</h6>
</div>

<div className="col-md-4 mb-3">
<span style={{fontSize:"12px"}}>Expiring On</span>
<h6>{domain.expire}</h6>
</div>

</div>

</Modal.Body>

</Modal>

);

};

export default DomainDetailModal;